<template>
  <div class="flex items-center gap-2 border-t border-border px-3 py-2">
    <Select :model-value="String(hour)" @update:model-value="emit('update:hour', Number($event))">
      <SelectTrigger class="w-[70px]">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem v-for="h in hours" :key="h" :value="String(h)">
          {{ h }}
        </SelectItem>
      </SelectContent>
    </Select>

    <span class="text-muted-foreground text-sm font-medium">:</span>

    <Select
      :model-value="disableMinute ? '0' : String(minute)"
      :disabled="disableMinute"
      @update:model-value="emit('update:minute', Number($event))"
    >
      <SelectTrigger class="w-[70px]">
        <SelectValue>{{ disableMinute ? '00' : String(minute).padStart(2, '0') }}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItem v-for="m in minutes" :key="m" :value="String(m)">
          {{ String(m).padStart(2, '0') }}
        </SelectItem>
      </SelectContent>
    </Select>

    <Select :model-value="period" @update:model-value="emit('update:period', $event as 'AM' | 'PM')">
      <SelectTrigger class="w-[70px]">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem v-for="p in periods" :key="p" :value="p">
          {{ p }}
        </SelectItem>
      </SelectContent>
    </Select>
  </div>
</template>

<script setup lang="ts">
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

type Props = {
  hour: number;
  minute: number;
  period: 'AM' | 'PM';
  disableMinute?: boolean;
};

withDefaults(defineProps<Props>(), { disableMinute: false });

const emit = defineEmits<{
  'update:hour': [value: number];
  'update:minute': [value: number];
  'update:period': [value: 'AM' | 'PM'];
}>();

const hours = Array.from({ length: 12 }, (_, i) => i + 1);
const minutes = Array.from({ length: 12 }, (_, i) => i * 5);
const periods: ('AM' | 'PM')[] = ['AM', 'PM'];
</script>
